import { OutlookNavigationRegion, CustomRegion } from 'outlook/interfaces/regionFilter/outlookNavigationRegionInterface';

class SplitByCharacter {
    letterMap: Map<string, Array<OutlookNavigationRegion | CustomRegion>>;

    constructor(hayStack: Array<object>) {
        this.letterMap = new Map();
        hayStack?.forEach((item: OutlookNavigationRegion | CustomRegion) => {
            const current = item.name ? item.name[0] : item.groupName[0];

            return this.letterMap.set(current, [...(this.letterMap.get(current) || []), item]);
        });
    }

    getKeysFromMap(): Array<string> | [] {
        return Array.from(this.letterMap.keys());
    }
    getItemsByKey(char: string): Array<OutlookNavigationRegion | CustomRegion> | [] {
        return this.letterMap.get(char) as Array<OutlookNavigationRegion | CustomRegion> | [];
    }
}

export { SplitByCharacter };
